/* eslint-disable react/react-in-jsx-scope */
import "@formatjs/intl-numberformat/polyfill"
import Breadcrumb from "components/Common/Breadcrumb"
import { get } from "helpers/api_helper"
import { useState } from "react"
import { Container } from "reactstrap"

import Grid from "components/Common/Grid"
import "./../../Monitoramento/Filters.css"
import CompaniesGrid from "./CompaniesGrid"
import "./CompanysForm.css"

function EmpresasMonitoradas() {
  document.title = "Empresas Monitoradas"
  const [companyType, setCompanyType] = useState("")
  const [data, setData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [showList, setShowList] = useState(true)
  const [searchTerm, setSearchTerm] = useState("")

  async function fetchEmpresasBtres({ companyType, page, searchValue }) {
    const url = `${process.env.REACT_APP_API_INT_LEADS}/api/${companyType}`
    const params = { page, size: 10 }
    
    if (searchValue) {
      // Detectar se é CNPJ (somente números) ou Nome Fantasia (contém letras)
      const hasLetters = /[a-zA-Z]/.test(searchValue)
      
      if (hasLetters) {
        // É Nome Fantasia
        params.nomeFantasia = searchValue
      } else {
        // É CNPJ - remove caracteres não numéricos
        params.cnpj = searchValue.replace(/\D/g, "")
      }
    }

    try {
      const data = await get(url, { params })
      const filteredData = data.data.filter(empresa => !empresa.DataExclusao)

      setData(filteredData)
      setCurrentPage(data.currentPage)
      setTotalPages(data.totalPages)
      return data
    } catch (error) {
      console.error("Erro ao buscar empresas", error)
      throw error
    }
  }

  const handleSearch = () => {
    if (companyType) {
      fetchEmpresasBtres({ companyType, page: 1, searchValue: searchTerm })
    }
  }

  const handleClearSearch = () => {
    setSearchTerm("")
    if (companyType) {
      fetchEmpresasBtres({ companyType, page: 1, searchValue: "" })
    }
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb
          title="Processamento"
          breadcrumbItem="Empresas Monitoradas"
        />
        <>
          <Grid>
            <select
              className="modern-select"
              value={companyType}
              onChange={e => {
                setCompanyType(e.target.value)
                setSearchTerm("")
                fetchEmpresasBtres({ companyType: e.target.value, page: 1, searchValue: "" })
                setShowList(true)
              }}
              id="dateTypeSelect"
            >
              <option value="" disabled>
                Selecione o tipo de empresa
              </option>
              <option value="empresas-b3">B3</option>
              <option value="empresas-devedoras">Devedora</option>
              <option value="empresas-monitoradas">Monitorada</option>
              <option value="empresas-ranking">Ranking</option>
              <option value="empresas-xp">XP</option>
            </select>
          </Grid>

          <CompaniesGrid
            companyType={companyType}
            data={data}
            currentPage={currentPage}
            totalPages={totalPages}
            setCurrentPage={fetchEmpresasBtres}
            setShowList={setShowList}
            showList={showList}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            handleSearch={handleSearch}
            handleClearSearch={handleClearSearch}
          />

          {/* {companySelected === "Empresa B3" && <BthreeCompanyContainer />}
          {companySelected === "Empresa devedora" && <DebtorCompanyContainer />}
          {companySelected === "Empresa Monitorada" && (
            <MonitoredCompanyContainer />
          )}
          {companySelected === "Empresa Ranking" && <CompanyRankingContainer />}
          {companySelected === "Empresa XP" && <CompanyXPContainer />} */}
        </>
      </Container>
    </div>
  )
}

export default EmpresasMonitoradas
